import {ChangeDetectionStrategy, Component, effect, signal} from '@angular/core';
import {NgClass, NgOptimizedImage} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DashboardStudyViewerMode} from '../../symbols';
import {DashboardStudyViewerControllerService} from '../../services/dashboard-study-viewer-controller/dashboard-study-viewer-controller.service';

@Component({
  selector: 'app-dashboard-study-viewer-controls-head-outline',
  templateUrl: './dashboard-study-viewer-controls-head-outline.component.html',
  styleUrls: ['./dashboard-study-viewer-controls-head-outline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, NgOptimizedImage, NgClass],
})
export class DashboardStudyViewerControlsHeadOutlineComponent {
  /** The control for the head outline visibility. */
  public readonly isHeadOutlineShown = signal(false);

  constructor(private studyViewerController: DashboardStudyViewerControllerService) {
    effect(() => {
      // Update the controls if the mode was changed outside the component.
      const studyViewerMode = this.studyViewerController.studyViewerMode();
      this.isHeadOutlineShown.set(
        studyViewerMode === DashboardStudyViewerMode.SurfaceWithProfile
      );

      // Toggle back to surface mode if the user is dragging the viewer as it breaks the alignment of the head outline and the brain image.
      const isDragging = this.studyViewerController.papayaController.isDragging();
      if (isDragging && studyViewerMode === DashboardStudyViewerMode.SurfaceWithProfile) {
        this.studyViewerController.updateViewerMode(DashboardStudyViewerMode.Surface);
      }
    });
  }

  /**
   * Toggles the visibility of the head outline.
   */
  public toggleHeadOutline(): void {
    this.isHeadOutlineShown.set(!this.isHeadOutlineShown());

    // Update the viewer mode based on the head outline visibility.
    if (this.isHeadOutlineShown()) {
      this.studyViewerController.updateViewerMode(DashboardStudyViewerMode.SurfaceWithProfile);
    } else {
      this.studyViewerController.updateViewerMode(DashboardStudyViewerMode.Surface);
    }
  }
}
